<div class="loading-spinner-container" *ngIf="active">
    <div class="spinner-content">
        <div class="spinner"></div>
        <div class="loading-message" *ngIf="message">
            {{message}}
        </div>
        <div class="continue-button-container" *ngIf="showContinueButton">
            <button type="button" class="continue-button"
                (click)="openNewTab()">
                Continuar navegando em outra aba
            </button>
        </div>
    </div>
</div>